import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import { Typography, Grid, Button } from "@material-ui/core";

import { styles } from "./KYC.styles";
import { formFields, formSchema } from "./KYC.schema";
import { Form, FormFields } from "../../../../common/forms";

import {
  selectIsLoading,
  selectCarclubDefaultConfigs,
  carclubGetConfigs,
  carclubUpdateDefaultConfigs,
} from "../../carclubSlice";

function KYC({ classes, disabled, submitRef }) {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);
  const loading = useSelector(selectIsLoading);
  const configs = useSelector(selectCarclubDefaultConfigs);

  useEffect(() => {
    if (!loading && !configs && !loaded) {
      dispatch(carclubGetConfigs());
      setLoaded(true);
    }
    // eslint-disable-next-line
  }, [loading]);

  const onSubmit = (values) => {
    let nConfigs = {
      ...configs,
      KYC_CONFIG: {
        ...values,
        mandatory: (values?.mandatory || [])
          .map((item) => item.trim())
          .filter((item) => item)
          .join(","),
      },
    };
    dispatch(carclubUpdateDefaultConfigs(nConfigs));
  };

  let initialValues = {
    ...(configs?.KYC_CONFIG || {}),
    mandatory: (configs?.KYC_CONFIG?.mandatory || "").split(","),
  };

  return (
    <div className={classes.root}>
      <Form
        schema={formSchema()}
        initialValues={initialValues}
        keepDirtyOnReinitialize
        onSubmit={onSubmit}
        render={({ submitting, values }) => {
          return (
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography className={classes.title}>KYC</Typography>
                <FormFields fields={formFields({ disabled, values })} />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={12}>
                <Button
                  style={{ display: "none" }}
                  ref={submitRef}
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={submitting}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          );
        }}
      />
    </div>
  );
}

export default withStyles(styles)(KYC);
